export const DEFAULT_MINUTES_PER_TASK = 5;

export const getStepKey = (step, index = 0) => {
  if (!step) return String(index + 1);
  const key = step.key ?? step.step ?? step.id ?? index + 1;
  return String(key);
};

const toContentMap = (stepsContent) => {
  if (!stepsContent) return {};

  if (Array.isArray(stepsContent)) {
    return stepsContent.reduce((acc, item, index) => {
      acc[getStepKey(item, index)] = item;
      return acc;
    }, {});
  }

  return Object.entries(stepsContent).reduce((acc, [key, value]) => {
    acc[String(key)] = value;
    return acc;
  }, {});
};

/**
 * Merges the steps returned by the server (order, name, completion) with the
 * locally described content. Server steps win; when they are missing the
 * content description is used as a standalone source of steps.
 */
export const normalizeSteps = (steps, stepsContent) => {
  const contentMap = toContentMap(stepsContent);

  const source =
    Array.isArray(steps) && steps.length > 0
      ? steps
      : Object.entries(contentMap).map(([key, value]) => ({
          ...value,
          step: value.step ?? key,
        }));

  return source.map((step, index) => {
    const key = getStepKey(step, index);
    const content = contentMap[key] || {};

    return {
      key,
      step: step.step ?? content.step ?? index + 1,
      name: step.name || content.name || "",
      complete: Boolean(step.complete),
      content,
    };
  });
};

export const countTasksLeft = (steps = []) =>
  steps.reduce((acc, step) => (step.complete ? acc : acc + 1), 0);

export const computeProgress = (steps = []) => {
  if (steps.length === 0) return 0;
  const completed = steps.filter((step) => step.complete).length;
  return Math.round((completed / steps.length) * 100);
};

export const resolveText = (text, params) =>
  typeof text === "function" ? text(params) : text;
